import styled from "styled-components";
import { Flex, Box } from "@edricphan2022/uikit";
import mediaQueries from "../../@uikit/theme/base";

export const Wrapper = styled(Box)`
  width: 100%;
  position: relative;
`;

export const CollapseStyle = styled(Box)`
  width: 100%;
  height: 100%;
  padding-top: 90px;
  padding-bottom: 236px;
  background-image: url("/assets/about/BannerAbout.svg");
  background-position: center;
  @media only screen and (max-width: 767px){
    padding-bottom: 170px;
  }
`;

export const ServicesTop = styled(Box)`
  padding-top: 80px;
  width: 100%;
  height: 100%;
`;

export const ServicesDesignAnd = styled(Box)`
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding-top: 195px;
  // background-image: url("/assets/home/backgroundV1.svg");
  background-position: center;
  position: relative;

  .content-about {
    white-space: break-spaces;
  }
  .ps-orbit {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .ps-services {
    display: block;
  }

  .cus-animated {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 14px;
  }
  h2{
    color: #303031;
    font-family: ManropeBold;
    font-size: 40px;
    font-weight: 700;  
    margin-bottom: 36px;
  }
`;

export const BoxScroll = styled(Flex)`
  width: 100%;
  height: 100%;
  background: #333333;
  min-height: 400px;
  position: absolute;
  bottom: 10%;
  justify-content: center;
  border-radius: 10px;

  & > * {
    width: 100%;
    place-items: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .name-posi {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .cus-button {
      background-color: transparent;
      border: none;
      outline: none;
      width: 20%;
      height: 60px;
      margin-top: 40px;
      z-index: 10;
      color: transparent;
      box-shadow: none;
    }
  }

  .cus-tablet {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;

    & > * {
      width: 50%;
    }

    & > *:nth-child(3) {
      width: 50%;
    }

    .cus-button {
      background-color: transparent;
      z-index: 10;
      color: transparent;
      box-shadow: none;
    }
  }

  .cus-button-tablet:nth-child(3) {
    width: calc(50%-48px);
  }

  /* .bt-orbit-1 {
    top: 7%;
    left: 15%;
  }

  .bt-orbit-2 {
    top: 5%;
    left: 66%;
  }

  .bt-orbit-3 {
    top: 42%;
    left: 38%;
  }

  .bt-orbit-4 {
    bottom: 15%;
    left: 15%;
  }

  .bt-orbit-5 {
    bottom: 20%;
    left: 66%;
  } */

  ${mediaQueries.mediaQueries.md} {
    .bt-orbit-1 {
      top: 7%;
      left: 5%;
    }

    .bt-orbit-2 {
      top: 5%;
      left: 55%;
    }

    .bt-orbit-3 {
      top: 42%;
      left: 30%;
    }

    .bt-orbit-4 {
      bottom: 12%;
      left: 5%;
    }
    .bt-orbit-1 , .bt-orbit-2 , .bt-orbit-3 , .bt-orbit-4{
      width: 50%;
    }

    .bt-orbit-5 {
      bottom: 12%;
      left: 55%;
    }
  }
`;

export const OurProcess = styled(Box)`
  width: 100%;
  height: 100%;
  // background: #fffdf9;
  min-height: 600px;
  padding-top: 48px;
  // background-image: url("/assets/home/backgroundV1.svg");
  background-position: center;
  position: relative;

  .content-about {
    white-space: break-spaces;
  }

  .content-whyBl {
    padding-bottom: 16px;
    display: flex;
    align-items: center;

    span {
      font-weight: bold;
    }
  }

  .cus-line {
    position: relative;
    display: inline-block;
    width: 18px;
    height: 2px;
    background: #f2e14c;
    margin-right: 14px;
  }

  .cus-gif {
    width: 400px;
    height: 400px;
    object-fit: cover;
  }
  h2{
    text-align: right;
    margin-right: 30px;
  }
  @media only screen and (max-width: 968px){
    h2{
      text-align: left;
    }
  }
`;

export const OurProcessBox = styled(Box)`
  width: 100%;
  height: 100%;

  .box-flex {
    & > *:nth-child(1) {
      width: 30%;
    }
    & > *:nth-child(2) {
      width: 70%;
      align-items: flex-start;
    }
  }

  .faq-item {
    & > *:nth-child(1) {
      width: 20%;
    }
    & > *:nth-child(2) {
      width: 80%;
    }
  }

  .content-about {
    white-space: break-spaces;
  }

  .faq-list {
    flex-wrap: wrap;
    padding: 20px 0;

    & > * {
      width: 50%;
      padding-bottom: 10px;
    }
  }

  .cus-line {
    position: relative;
    display: inline-block;
    width: 18px;
    height: 2px;
    background: #f2e14c;
    margin-right: 14px;
  }

  ${mediaQueries.mediaQueries.lg} {
    .box-flex {
      flex-direction: column;
      gap: 60px;
      /* align-items: flex-start; */
      & > * {
        width: 100% !important;
      }
    }
    /* .faq-item {
      & > * {
        width: 100% !important;
      }
    } */
  }

  ${mediaQueries.mediaQueries.md} {
    .faq-item {
      flex-direction: column;
      & > * {
        width: 100% !important;
      }
    }
  }

  ${mediaQueries.mediaQueries.sm} {
    .faq-list {
      & > * {
        width: 100%;
      }
    }
  }
`;

export const IndustryExpertise = styled(Box)`
  width: 100%;
  padding-top: 48px;
  padding-bottom: 48px;

  .content-about {
    white-space: break-spaces;
  }
`;

export const BoxExpertise = styled(Flex)`
  flex-wrap: wrap;
  & > * {
    width: calc(3 / 12 * 100%);
    padding: 8px;
  }

  .box-children {
    padding: 20px 17px;
    border: 1px solid #e7e7e8;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) -30.29%, rgba(255, 255, 255, 0) 144.92%);
    backdrop-filter: blur(50px);
    border-radius: 15px;
    min-height: 330px;

    .item-icon {
      position: relative;
      margin-bottom: 36px;
      ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(255, 237, 155, 0.5) 12.79%, rgba(247, 218, 87, 0) 69.15%);
        border-radius: 30px 0px 0px 30px;
        z-index: -1;
      }
    }
  }

  ${mediaQueries.mediaQueries.xl} {
    & > * {
      width: calc(4 / 12 * 100%);
      padding: 8px;
    }
  }

  ${mediaQueries.mediaQueries.md} {
    & > * {
      width: calc(6 / 12 * 100%);
    }
  }

  ${mediaQueries.mediaQueries.sm} {
    & > * {
      width: 100%;
    }
  }
`;

export const BoxCompetencies = styled(Flex)`
  flex-wrap: wrap;
  & > * {
    width: calc(4 / 12 * 100%);
    padding: 8px;
  }

  .box-children {
    padding: 20px 17px;
    border: 1px solid #e7e7e8;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) -30.29%, rgba(255, 255, 255, 0) 144.92%);
    backdrop-filter: blur(50px);
    border-radius: 15px;
    min-height: 361px;

    .item-icon {
      position: relative;
      margin-bottom: 36px;
      ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(255, 237, 155, 0.5) 12.79%, rgba(247, 218, 87, 0) 69.15%);
        border-radius: 30px 0px 0px 30px;
        z-index: -1;
      }
    }
  }

  ${mediaQueries.mediaQueries.xl} {
    .box-children {
      min-height: 500px;
    }
  }

  ${mediaQueries.mediaQueries.md} {
    & > * {
      width: calc(6 / 12 * 100%);
    }
  }

  ${mediaQueries.mediaQueries.sm} {
    & > * {
      width: 100%;
      min-height: auto;
    }

    .box-children {
      min-height: auto;
      padding-bottom: 30px;
    }
  }
`;

export const BoxBlockchainTech = styled(Flex)`
  flex-wrap: wrap;
  & > * {
    width: calc(6 / 12 * 100%);
    padding: 8px;
  }

  .box-children {
    padding: 20px 17px;
    /* border: 1px solid #e7e7e8;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.03) -30.29%, rgba(255, 255, 255, 0) 144.92%);
    backdrop-filter: blur(50px); */
    border-radius: 15px;
    min-height: 500px;

    .item-icon {
      position: relative;
      margin-bottom: 36px;
      /* ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(255, 237, 155, 0.5) 12.79%, rgba(247, 218, 87, 0) 69.15%);
        border-radius: 30px 0px 0px 30px;
        z-index: -1;
      } */
    }
  }

  ${mediaQueries.mediaQueries.md} {
    & > * {
      width: 100%;
    }

    .box-children {
      min-height: auto;
    }
  }
`;

export const BlockchainServices = styled(Box)`
  width: 100%;
  height: 100%;
`;

export const OurCompetencies = styled(Box)`
  width: 100%;
  height: 100%;
  background: #ffffff;
  min-height: 600px;
  padding-top: 48px;
  padding-bottom: 48px;
  background-image: url("/assets/home/backgroundV1.svg");
  background-position: center;
  position: relative;
`;

export const TextCenter = styled.div`
  width: 100%;
  background: linear-gradient(90deg, rgba(255, 237, 155, 0) 3.37%, rgba(251, 228, 124, 0.5) 45.49%, rgba(247, 218, 87, 0) 95.86%);
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: center;
  h3{
    text-align: center;
    color: #303031;
    font-size: 20px;
    font-weight: 700;
    font-family: ManropeBold;

  }
`
export const ContentGroup = styled.div`
  width: 89.9%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 1726px;
  margin: auto;
  padding: 0px 0px;
  margin-top: 50px;
`
export const ContentBox = styled.div<{BgImg?:boolean}>`
  width: 50%;
  margin-bottom: 70px;
  div{
    display: flex;
    align-items: center;
    height: 69px;
  }
  .IconServices{
    width: 69px;
    height: 69px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({BgImg})=>BgImg ? 'transparent' : '#F7DA57'};
    border-radius : 20px;
    margin-right: 14px;
    min-width: 69px;
  }
  h3{
    color: #333333;
    font-size: ${({BgImg})=>BgImg ? '24px' : '16px'};
    font-weight: ${({BgImg})=>BgImg ? '700' : '200'};
    font-family : ManropeBold;
    letter-spacing: 4.2px;
  }
  p{
    margin-left: 83px;
    font-size: 20px;
    font-weight: 400;
    font-family : ManropeRegular;
    color: #333333;
    max-width: 462px;
  }
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`